export const validation = {
  titleMaxChar: 100,
  blockTitleMaxChar: 30,
  blockParagraphMaxChar: 100,
  blocks: {
    min: 1,
    max: 6
  }
}